import { connectDeep } from 'redux-utils';

import { enableOsPermission } from 'actions/gallery';
export { useAbstractEditor } from './AbstractEditor';
export { default as List } from './List';
export { default as WarningIcon } from './WarningIcon';

const mapStateToProps = (state, { app }) => {
  const {
    gallery: { osPermissions }
  } = state;

  const { grantedPermissions, requestedPermissions } = app;

  const permissions = {};
  for (const permission of requestedPermissions) {
    // False by default if not already set
    permissions[permission] = grantedPermissions[permission] === true;
  }

  // Set OS permissions to off if denied for Fitbit iOS/Android
  const osPermissionsMap = app.osPermissionsEnableableMap;

  for (const permission in osPermissionsMap) {
    if (osPermissionsMap[permission]) {
      permissions[permission] = false;
    }
  }

  return {
    osPermissions,
    permissions
  };
};

const mapDispatchToProps = (dispatch, { app }) => ({
  enableOsPermission: (permissionType) =>
    dispatch(
      enableOsPermission(permissionType, {
        appName: app.name
      })
    )
});

export const connect = (component) =>
  connectDeep(mapStateToProps, mapDispatchToProps)(component);
